import { createApiServices } from '@pf126/api-maker'

export default createApiServices({
    baseUrl: `${process.env.REACT_APP_URL_FFM}/api`
})

